import { Box, Skeleton, Grid } from '@mui/material'
import React from 'react'

type StepperBoxSkeletonProps = { count?: number }

function StepperBoxSkeleton({ count = 9 }: StepperBoxSkeletonProps) {
  const NO_OF_ITEMS_ARRAY: number[] = []

  for (let i = 1; i <= count; i++) {
    NO_OF_ITEMS_ARRAY.push(i)
  }
  return (
    <Grid container>
      <Grid container>
        <Grid item>
          <Skeleton
            variant='text'
            width={200}
            height={60}
          />
        </Grid>
      </Grid>
      <Grid
        container
        marginBottom={2}
      >
        <Grid item>
          <Skeleton
            variant='text'
            width={400}
            height={40}
          />
        </Grid>
      </Grid>
      {NO_OF_ITEMS_ARRAY.map((value) => (
        <Grid
          item
          xs={4}
          key={value}
        >
          <Box
            display={'flex'}
            flexDirection='column'
            justifyContent='center'
            borderRadius='10px'
            sx={{ aspectRatio: '2/1' }}
            margin={2}
            alignItems='center'
            bgcolor={(theme) => theme.palette.bgGray.main}
          >
            <Skeleton
              variant='text'
              sx={{ fontSize: '1.3rem' }}
              width={50}
            />
          </Box>
        </Grid>
      ))}
    </Grid>
  )
}

export default StepperBoxSkeleton
